export default __webpack_public_path__ + "static/media/mosto.8c42755b.jpg";